/**
 * 权限配置 - 集中管理权限相关的 userCode 列表
 */

// 有屏体管控权限的 userCode 列表
export const SCREEN_CONTROL_CODES = ['J00000733', 'J00000704'];
